import { useEffect, useState } from 'react'
import { useRecordContext } from 'react-admin'
import Api from '../../../Apis/api.service'
import { usePrompt } from '../../common/PromptBlocker'
import { ResolutionAccordion } from './ResolutionComponent'

export const ResolutionsComponent = () => {
  let ag = useRecordContext()
  const [openResolutionId, setOpenResolutionId] = useState(
    ag.open_resolution_id
  )
  const [resolutions, setResolutions] = useState(ag.resolutions)
  const [lastRefreshTime, setLastRefreshTime] = useState(new Date())
  const [isChanged, setIsChanged] = useState(new Date().getTime())
  const [isSomeThingsChange, setIsSomeThingsChange] = useState([])

  useEffect(async () => {
    const id = ag.id
    const result = await Api.ags3.get(id)
    if (result.status === 200) {
      setResolutions([...result.data.resolutions])
    }
  }, [isChanged])

  usePrompt(
    'Vous avez des changements non enregistrés. Voulez-vous vraiment quitter cette page ?',
    isSomeThingsChange.length
  )

  return (
    <>
      {resolutions.map((resolution) => {
        return (
          <ResolutionAccordion
            key={resolution.id}
            resolution={resolution}
            ag={ag}
            setOpenResolutionId={setOpenResolutionId}
            setLastRefreshTime={setLastRefreshTime}
            lastRefreshTime={lastRefreshTime}
            openResolutionId={openResolutionId}
            setIsChanged={setIsChanged}
            isChanged={isChanged}
            isSomeThingsChange={isSomeThingsChange}
            setIsSomeThingsChange={setIsSomeThingsChange}
            resolutions={resolutions}
          />
        )
      })}
    </>
  )
}
export default ResolutionsComponent
